import React from 'react';

import styles from './Result.module.scss';
import { useSelector } from 'react-redux';
import hash from '../../Utils/hash';
import externalLink from '../../img/external_link.svg';

const Result = (props) => {
  const {
    title,
    url,
    text,
    typeColor,
    icon,
    type,
    niva,
    image,
    greyBox,
    larested,
    stedsnavn,
    isClickable = true
  } = props;
  const newFilterState = useSelector((state) => state.newFilterReducer);
  const isMobile = newFilterState.isMobile;

  const regex = /(karriereveiledning\.no)\//;
  const isExternal = regex.test(url);
  let externalHost = null;
  if (isExternal) {
    const [, host] = regex.exec(url);
    externalHost = ` - ${host.charAt(0).toUpperCase()}${host.substring(1)}`;
  }

  let placeInfoR = [];

  if (
    niva === 'Universitet og høgskole' ||
    niva === 'Emne og kurs' ||
    niva === 'Fagskole' ||
    niva === 'Annen utdanning' ||
    niva === 'Folkehøgskole' ||
    niva === 'Videregående' ||
    niva === 'Privat videregående'
  ) {
    let i = 0;
    let placeArray = [];

    if (niva !== 'Privat videregående') {
      placeArray = [larested, stedsnavn];
    } else {
      placeArray = /^Tilbys på/.test(stedsnavn)
        ? [stedsnavn]
        : [larested, stedsnavn];
    }
    placeArray.map((placeinfo) => {
      if (placeinfo && placeinfo.length) {
        placeInfoR.push(<span key={hash(placeinfo) + ++i}>{placeinfo}</span>);
      }
      return true;
    });
  }

  let missingImageStyle = null;

  if (!image) {
    missingImageStyle = styles.resultinfo_noImage;
  }

  const handleClick = (e) => {
    window.location.href = url;
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      // Handle enter
      e.target.click();
    }
  };

  const handleHover = (e) => {
    let prefetch = document.querySelector('link[href="' + url + '"]');

    // Prefetch touched/hovered link
    if (!prefetch) {
      prefetch = document.createElement('link');
      prefetch.setAttribute('rel', 'prefetch');
      prefetch.setAttribute('href', url);
      document.head.appendChild(prefetch);
    }
  };

  if (isMobile) {
    return (
      <div
        onClick={isClickable ? handleClick : undefined}
        onKeyDown={isClickable ? handleKeyDown : undefined}
        onTouchStart={isClickable ? handleHover : undefined}
        // KI-20
        className={`${styles.resultcontainer} ${isClickable && isClickable !== undefined ? `${styles.resultcontainer_clickable}` : `${styles.resultcontainer_nonClickable}`}`}
      >
        <div className={styles.resultcontent}>
          <div className={`${styles.resultinfo} ${missingImageStyle}`}>
            <div>
              {image ? (
                <div className={styles.imagecontainer}>
                  <img src={image.url} alt={image.alt} title={image.title} />
                </div>
              ) : null}

              <div className={styles.resultheader}>
                {icon ? (
                  <div className={styles.resulticon} aria-hidden='true'>
                    <img class={`${!isClickable ? `${styles.resultKiIcon}`: ""}`} src={icon} alt='' />
                  </div>
                ) : null}

                <div className={styles.resulttype}>
                  {type}
                  {externalHost}
                </div>
                {typeColor ? (
                  <div
                    className={styles.resulttypecolor}
                    data-type-color={typeColor}
                  ></div>
                ) : null}
                {niva !== 'Intervju' ? (
                  <div className={styles.resultniva}>{niva}</div>
                ) : null}
              </div>

              <div className={styles.resulttitle}>
                <h2>
                  {niva === 'Intervju' ? niva + ':' + title : title}
                  {isExternal && (
                    <img
                      className={styles.resulttitle_external}
                      src={externalLink}
                    />
                  )}
                </h2>
              </div>
            </div>

            <div className={styles.resulttext}>
              <p>{text}</p>
            </div>

            {greyBox && <div className={styles.resultgreybox}>{greyBox}</div>}

            {placeInfoR.length > 0 && (
              <div className={styles.resultplaceinfo}>{placeInfoR}</div>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        onClick={isClickable ? handleClick : undefined}
        onKeyDown={isClickable ? handleKeyDown : undefined}
        onMouseEnter={isClickable ? handleHover : undefined}
        // KI-20
        className={`${styles.resultcontainer} ${isClickable && isClickable !== undefined ? `${styles.resultcontainer_clickable}` : `${styles.resultcontainer_nonClickable}`}`}
      >
        <div className={styles.resultcontent}>
          <div className={`${styles.resultinfo} ${missingImageStyle}`}>
            <div className={styles.resultheader}>
              {icon ? (
                <div className={styles.resulticon} aria-hidden='true'>
                  <img class={`${!isClickable ? `${styles.resultKiIcon}`: ""}`} src={icon} alt='' />
                </div>
              ) : null}

              <div className={styles.resulttype}>
                {type}
                {externalHost}
              </div>

              {typeColor ? (
                <div
                  className={styles.resulttypecolor}
                  data-type-color={typeColor}
                ></div>
              ) : null}

              {niva !== 'Intervju' ? (
                <div className={styles.resultniva}>{niva}</div>
              ) : null}
            </div>

            <a href={url}>
              <div className={styles.resulttitle}>
                <h2>
                  {niva === 'Intervju' ? niva + ':' + title : title}
                  {isExternal && (
                    <img
                      className={styles.resulttitle_external}
                      src={externalLink}
                    />
                  )}
                </h2>
              </div>
              <div className={styles.resulttext}>
                <p>{text}</p>
              </div>
            </a>
            {greyBox && <div className={styles.resultgreybox}>{greyBox}</div>}
            {placeInfoR.length > 0 && (
              <div className={styles.resultplaceinfo}>{placeInfoR}</div>
            )}
          </div>

          {image ? (
            <div className={styles.imagecontainer}>
              <img src={image.url} alt={image.alt} title={image.title} />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
};

export default Result;
